<template>
  <div id="hrms19x">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :unLoadBool="true"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHrms19xIndex"
            :maxRowspan="maxRowspan.index"
            :csvExportDisp="true"
            :sortDisp="false"
            searchBoxAlias="hrms19x"
            :callSearchEvent="callSearchEvent" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms19x/mutation-types'
import moment from 'moment'

export default {
  name: 'hrms19x',
  data () {
    return {
      searchIndex: {
        dtestrt: '01/' + moment().format('MM/YYYY'),
        dteend: moment().format('DD/MM/YYYY'),
        codcomp: ''
      },
      app: this.$root.$children[0],
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHrms19xColumnsLabels()
    let currnetUser = this.$root.$children[0].currentUser
    if (typeof currnetUser.usrcom[0] !== 'undefined') {
      this.searchIndex.codcomp = currnetUser.usrcom[0]
    }
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS19X_INDEX_DISP,
      columns: types.GET_HRMS19X_COLUMNS,
      labels: types.GET_HRMS19X_LABELS,
      index: types.GET_HRMS19X_INDEX,
      maxRowspan: types.GET_HRMS19X_MAX_ROWSPAN
    })
  },
  methods: {
    callSearchEvent () {
      if (this.searchIndex.codempid !== '') {
        this.searchIndex.codcomp2 = ''
        this.searchIndex.codcalen = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS19X_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS19X_PAGE,
      receivedHrms19xColumnsLabels: types.RECEIVED_HRMS19X_COLUMNS_LABELS,
      receivedHrms19xIndex: types.RECEIVED_HRMS19X_INDEX
    })
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?286a75d1